import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { I18nProvider } from "./i18n";
import { detectLocale } from "./i18n/detectLocale";
import { getSync } from "./services/sync";
import { ErrorBoundary } from "./components/app/ErrorBoundary";
import { captureInstallPrompt } from "./hooks/useInstallPrompt";
import "./index.css";

const initialLocale = detectLocale();

// T-025: the sync engine is a singleton constructed on first access.
// Touching it here so the auth subscription (which sets the owner on
// sign-in and clears it on sign-out) is wired before the first write.
getSync();

// T-064: capture the native install prompt as early as possible so it does not
// flash before React has mounted the install card.
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", captureInstallPrompt);
  // Record app-open timestamp for the engagement-gated install card.
  if (typeof localStorage !== "undefined" && !localStorage.getItem("pwa.appOpenAt")) {
    localStorage.setItem("pwa.appOpenAt", String(Date.now()));
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider initial={initialLocale}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </I18nProvider>
  </StrictMode>,
);
